var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Watch } from "vue-facing-decorator";
import { MeasurementTypesClient, MeasurementCategoriesClient, GetMeasurementTypeListPaginatedQuery, PaginatedEnumerableOfMeasurementTypeModel, MeasurementTypeModel, UpdateMeasurementTypeCommand, CreateMeasurementTypeCommand, ComponentTypesClient } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
const componentTypeClient = new ComponentTypesClient(window.apiUrl);
const measurementTypeClient = new MeasurementTypesClient(window.apiUrl);
const measurementCategoryClient = new MeasurementCategoriesClient(window.apiUrl);
let MeasurementTypesVue = class MeasurementTypesVue extends Vue {
    constructor() {
        super(...arguments);
        // simpletons
        this.working = false;
        this.searchAttempted = false;
        // models
        this.query = new GetMeasurementTypeListPaginatedQuery({
            pageNo: 1,
            pageSize: 100,
        });
        this.data = new PaginatedEnumerableOfMeasurementTypeModel();
        // arrays
        this.componentTypes = [];
        this.measurementCategories = [];
    }
    created() {
        this.getLookups();
    }
    ;
    // get
    search() {
        if (this.working)
            return;
        if (!this.query)
            return;
        this.working = true;
        measurementTypeClient
            .getListPaginated(this.query)
            .then(response => {
            if (!response)
                return;
            this.data = response;
            this.query.pageNo = this.data.displayedPage;
            this.query.pageSize = this.data.pageSize;
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.searchAttempted = true;
        });
    }
    ;
    getLookups() {
        let promises = [
            componentTypeClient
                .getList()
                .then(response => {
                if (!response)
                    return;
                this.componentTypes = response.map((item) => {
                    return {
                        value: item.componentTypeId || 0,
                        text: item.componentTypeName
                    };
                });
            })
                .catch((ex) => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            }),
            measurementCategoryClient
                .getList()
                .then(response => {
                if (!response)
                    return;
                this.measurementCategories = response.map((item) => {
                    return {
                        value: item.measurementCategoryId || 0,
                        text: item.measurementCategoryName
                    };
                });
            })
                .catch((ex) => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
        ];
        Promise
            .all(promises)
            .then(() => {
            this.search();
        });
    }
    ;
    // set
    add() {
        let measurementType = new MeasurementTypeModel({
            measurementTypeId: 0,
            measurementTypeName: "",
            unitOfMeasurement: "",
            unitOfMeasurementImperial: "",
            unitOfMeasurementCode: "",
            unitOfMeasurementCodeImperial: "",
            conversionFactor: null,
            conversionAdditionalFactor: null
        });
        if (!this.data.records)
            this.data.records = new Array();
        this.data.records.unshift(measurementType);
    }
    ;
    save(measurementType) {
        if (!measurementType.measurementTypeName || !measurementType.unitOfMeasurement || !measurementType.unitOfMeasurementCode) {
            Notifier.onError("Please enter all required fileds.");
            return;
        }
        let promise = () => {
            return measurementType.measurementTypeId
                ? measurementTypeClient.update(measurementType.measurementTypeId, new UpdateMeasurementTypeCommand({ requestModel: measurementType }))
                : measurementTypeClient.add(new CreateMeasurementTypeCommand({ requestModel: measurementType }));
        };
        promise()
            .then(() => {
            Notifier.onOk(this);
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.search();
        });
    }
    ;
    purge(measurementType) {
        if (!measurementType.measurementTypeId && this.data.records) {
            this.data.records.splice(this.data.records.indexOf(measurementType), 1);
            return;
        }
        this.$confirmModal.show("Are you sure that you want to permanently delete this measurement type? This action cannot be undone.", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            measurementTypeClient
                .delete(measurementType.measurementTypeId)
                .then(() => {
                Notifier.onOk();
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.search();
            });
        });
    }
    ;
    // computed
    get noData() {
        return this.searchAttempted && (!this.data || !this.data.records || !this.data.records.length);
    }
};
__decorate([
    Watch("query.pageNo"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MeasurementTypesVue.prototype, "search", null);
MeasurementTypesVue = __decorate([
    Component({
        name: "MeasurementTypesVue"
    })
], MeasurementTypesVue);
export default MeasurementTypesVue;
